
import Royal from "../assets/Ovation.jpg" ;
import Ama from "../assets/Ama.webp" ;
import Antarctica from "../assets/Antarctica.webp" ;
import Avalon from "../assets/Avalon-Waterways-jpg.webp" ;
import Azamara from "../assets/azamara-quest-sunset-logo-update-scaled (1).jpg" ;
import Carnival from "../assets/carnival-cruise-wallpapers (1).jpg" ;
import Celebrity from "../assets/CEL-Eclipse.jpg" ;
import Norwegian from "../assets/NCL-Int2cruises.webp" ;
import Disney from "../assets/disney.webp" ;
import Princess from "../assets/Ovation.jpg" ;
import Genting from "../assets/genting_2nights.jpg";
import Cordelia from "../assets/cordelia.webp" ;

const BrandDeal = [
    {
        img:Royal,
        offer: "Get 60% Off On Second Guest" ,
        brand : "Royal Caribbean",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Ama,
        offer: "Upto 20% Cruise Savings" ,
        brand : "AmaWaterways",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=8138&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=8138&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=8138&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },
    {
         img:Antarctica,
        offer: "Enjoy a Saving of USD $2000 Per Person" ,
        brand : "Antarctica21",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=8282&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&cruiseline=8282&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=8282&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&cruiseline=8282&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
         img:Avalon,
        offer: "Save $1,500 Per Person" ,
        brand : "Avalon Waterways",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=8121&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&cruiseline=8121&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=8121&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&cruiseline=8121&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Azamara,
        offer: "Get Upto $1000 Onboard Credit" ,
        brand : "Azamara Cruises",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=1043&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&cruiseline=1043&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=1043&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&cruiseline=1043&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
         img:Carnival,
        offer:" Get Upto 50% Off + Upto $50 Onboard Credit" ,
        brand : "Carnival Cruise",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=1&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=1&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=1&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=1&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Celebrity,
        offer:" Get 75% Off On Second Guest" ,
        brand :" Celebrity Cruises",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=2&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=2&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=2&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=2&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Norwegian,
        offer:" Get 50% Off + Free Perks" ,
        brand :"Norwegian Cruise Line",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&cruiseline=6&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Disney,
        offer:" Save Upto 20%" ,
        brand :" Disney Cruise",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=4&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318lang=1&destinationtype=All&cruiseline=4&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=4&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=4&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    },

    {
        img:Princess,
        offer:" Upto 40% Off + Free Upgrade and 3rd & 4th Guest Free" ,
        brand :" Princess Cruise",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc"
    }
    }
,

    {
        img:Genting,
        offer:"3rd & 4th Guest Free" ,
        brand :"Stardream Cruise",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&Ship=15512&sortColumn=cruiselinePriority&sortOrder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&Ship=15512&sortColumn=cruiselinePriority&sortOrder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1227501&lang=1&destinationtype=All&Ship=15512&sortColumn=cruiselinePriority&sortOrder=asc"
    }
    }
    ,

    {
        img:Cordelia,
        offer:"" ,
        brand :"Cordelia Cruise",
        // link:"https://booking.int2cruises.com/swift/cruise?siid=1228312&lang=1&destinationtype=All&cruiseline=7&sortcolumn=cruiselinePriority&sortorder=asc"
        links: {
      INR: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&CruiseLine=9190&sortColumn=cruiselinePriority&sortOrder=asc",
      USD: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&CruiseLine=9190&sortColumn=cruiselinePriority&sortOrder=asc",
      SGD: "https://booking.int2cruises.com/swift/cruise?siid=1237318&lang=1&destinationtype=All&CruiseLine=9190&sortColumn=cruiselinePriority&sortOrder=asc"
    }
    }
]

export default BrandDeal ;